export const pendingSavesSessionStorageKey = 'pendingFavorites';
export const favoritesSessionStorageKey = 'favorites';
